import React, { useContext, useEffect, useState } from 'react'

import { WappContext, withWapp } from 'wapplr-react/dist/common/Wapp'

import getUtils from 'wapplr-react/dist/common/Wapp/getUtils'
import Paper from 'karrierhub-ui/dist/common/src/components/Paper'
import Typography from 'karrierhub-ui/dist/common/src/components/Typography'
import BellIcon from 'karrierhub-ui/dist/common/src/svg/BellIcon'

function _NotificationIcon(props) {

    const { subscribe, classNames } = props

    const context = useContext(WappContext)
    const { res } = context
    const utils = getUtils(context)
    const user = utils.getRequestUser()

    let initialPost = user
    const postFromRequest = res.wappResponse.store.getState('res.responses.' + 'user' + 'Overview')
    if (postFromRequest && postFromRequest._id === user?._id) {
        initialPost = postFromRequest
    }

    const [notificationsNumber, setNotificationsNumber] = useState(initialPost?.unseenNotificationsNumber || 0)

    const requestKeys = ['userOverview', 'userClearUnseenNotificationsNumber']

    function onRequestResolved({ value }) {
        if (user?._id) {
            const keys = [...requestKeys]
            const response = value
            let updated = false
            keys.forEach(function(requestName) {
                if (!updated && response && response[requestName]?._id === user._id) {
                    updated = true
                    if (response[requestName].unseenNotificationsNumber !== notificationsNumber) {
                        setNotificationsNumber(response[requestName].unseenNotificationsNumber || 0)
                        if (requestName === 'userClearUnseenNotificationsNumber') {
                            // noinspection JSIgnoredPromiseFromCall
                            request()
                        }
                    }
                }
            })
        }
    }

    async function request() {
        await utils.sendRequest({
            requestName: 'user' + 'Overview',
            args: {
                _id: user?._id
            }
        })
    }

    useEffect(function() {
        const unsub = subscribe.requestResolved(onRequestResolved)
        return function useUnsubscribe() {
            unsub()
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [user?._id])

    if (!user?._id) {
        return null
    }

    return (
        <div className={classNames.notificationIcon}>
            {notificationsNumber ?
                <Paper
                    color={'primary'}
                    variant={'contained'}
                    className={classNames.notificationIconNumber}
                    elevation={0}
                >
                    <Typography fontSize={'0.8em'}>
                        {notificationsNumber}
                    </Typography>
                </Paper> : null
            }
            <BellIcon />
        </div>
    )
}

export const NotificationIcon = withWapp(_NotificationIcon)
